import { CoreIcon } from '../core-icon';
import carwashFillSVG from '../../assets/icons/carwash-fill.svg';
import type { IconProps } from '../core-icon';

export const CarwashFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={carwashFillSVG} {...props} />;
};
